export default {
  title: {
    id: 'merchant_options_payment_payout_information_for_market',
    defaultMessage: 'Payout information for: {market}',
  },
  providePaymentInfos: {
    id: 'merchant_options_payment_payout_information_cta',
    defaultMessage: 'Provide your payment information',
  },
}
